import momentsOfHandHygiene from './moments-of-hand-hygiene/index.json';
import scenarioX from './scenario-x/index.json';

const momentsOfHandHygieneAnimations = {
    momentsOfHandHygiene,
    scenarioX,
};

export default momentsOfHandHygieneAnimations;
